import Swiper from 'swiper';
import { getScreenSize, mediaBreakpoints } from '../js/utils/helpers';

const selectors = {
    isMobile: getScreenSize(mediaBreakpoints.mobileMax),
    number: document.querySelector('.number'),
    arrowLeft: document.querySelector('.arrow-left'),
    arrowRight: document.querySelector('.arrow-right'),
    hotSpots: document.querySelector('.experience-items'),
    videoIframe: document.querySelector('.hotspot-wrapper iframe')
};

const hotSpotsArr = Array.from(selectors.hotSpots.children);

const swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    on: {
        slideChange() {
            selectors.number.textContent = `0${this.activeIndex + 1}`;

            if (this.activeIndex >= 1) {
                selectors.arrowLeft.classList.add('enabled');
            } else {
                selectors.arrowLeft.classList.remove('enabled');
            }
            if (
                this.activeIndex + 1
                === +selectors.number.dataset.slideNumber
            ) {
                selectors.arrowRight.classList.add('disabled');
            } else {
                selectors.arrowRight.classList.remove('disabled');
            }

            hotSpotsArr.forEach((i) => i.classList.remove('blink', 'active'));
            hotSpotsArr[this.activeIndex].classList.add(
                'blink',
                'active'
            );
        }
    }
});

const HotSpot = {
    init() {
        hotSpotsArr[0].classList.add('blink', 'active');
        selectors.hotSpots.addEventListener('click', (e) => {
            hotSpotsArr.forEach((i) => i.classList.remove('blink', 'active'));
            const clicked = e.target.closest(
                '.experience-commerce_assets-hotspotmarker'
            );
            if (!clicked) return;
            swiper.slideTo(hotSpotsArr.indexOf(clicked));
            clicked.classList.add('blink', 'active');
        });

        selectors.arrowLeft.addEventListener('click', () => {
            swiper.slidePrev();
        });
        selectors.arrowRight.addEventListener('click', () => {
            swiper.slideNext();
        });

        if (selectors.videoIframe && selectors.isMobile) {
            selectors.videoIframe.src = selectors.videoIframe.dataset.srcMobile;
        }
    }
};

HotSpot.init();
